<template>
    <div v-if="c_data">
        <div v-if="c_type=='object'">
            <div v-if="show_info">
                <RowComponent
                    :label="'tensione alimentazione'"
                    :value="c_data.power_supply">
                </RowComponent>
                <RowComponent
                    :label="'frequenza alimentazione'"
                    :value="c_data.frequency">
                </RowComponent>
                <RowComponent
                    :label="'intervallo temperatura'"
                    :value="c_data.temperature_range">
                </RowComponent>
                <RowComponent
                    :label="'pressione fluido di lavoro'"
                    :value="c_data.fluid_pressure">
                </RowComponent>
                <RowComponent
                    :label="'modalità variazione velocità nastro'"
                    :value="c_data.speed_type">
                </RowComponent>
                <RowComponent
                    :label="'velocità minima'"
                    :value="c_data.min_speed">
                </RowComponent>
                <RowComponent
                    :label="'velocità massima'"
                    :value="c_data.max_speed">
                </RowComponent>
                <RowComponent
                    :label="'tara additiva'"
                    :value="c_data.add_tare">
                </RowComponent>
                <RowComponent
                    :label="'tara sottrattiva'"
                    :value="c_data.sub_tare">
                </RowComponent>
                <RowComponent
                    label="p.ti di appoggio"
                    :value="c_data.support_points">
                </RowComponent>
                
            </div>
            <v-form ref="object" v-else v-model="valid.object">
            <v-container class="py-0">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-text-field dense outlined
                            label="tensione alimentazione"
                            v-model="c_data.power_supply"/>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-text-field dense outlined
                            label="frequenza"
                            v-model="c_data.frequency"/>
                    </v-col>
                    
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-text-field dense outlined
                            label="intervallo temperatura"
                            v-model="c_data.temperature_range"/>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-text-field dense outlined
                            label="pressione fluido lavoro"
                            v-model="c_data.fluid_pressure"/>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="4">
                        <v-text-field dense outlined
                            label="variazione velocità nastro"
                            v-model="c_data.speed_type"/>
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <v-text-field dense outlined
                            label="velocità minima"
                            v-model="c_data.min_speed"/>
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <v-text-field dense outlined
                            label="velocità massima"
                            v-model="c_data.max_speed"/>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        <NumericField dense outlined
                            label="tara additiva"
                            :suffix="uom"
                            v-model="c_data.add_tare"/>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <NumericField dense outlined
                            label="tara sottrattiva"
                            :suffix="uom"
                            :rules="[rules.mandatory]"
                            v-model="c_data.sub_tare"/>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="8">
                        <NumericField dense outlined
                            label="p.ti di appoggio (*VP)"
                            :precision="0"
                            :rules="[rules.mandatory]"
                            v-model="c_data.support_points">
                        </NumericField>
                    </v-col>
                </v-row>
            </v-container>
            </v-form>
        </div>
        <div v-if="c_type=='metro'">
             <!-- LEG -->
            <div v-if="r_type == 'leg'">
                <div v-if="show_info">
                    <div v-if="!c_data.metro_national">
                        <RowComponent
                            :label="'anno marcatura CE'"
                            :value="c_data.CE_year">
                        </RowComponent>
                        
                        <RowComponent
                            :label="'numero attestazione/certificazione'"
                            :value="c_data.cert_number">
                        </RowComponent>
                        <RowComponent
                            :label="'org. notificato'"
                            :value="c_data.org_notified">
                        </RowComponent>
                        
                        <RowComponent
                            :label="'data messa in servizio'"
                            :value="c_data.commissioning_date">
                        </RowComponent>
                        <RowComponent
                            :label="'modulo accertamento conformità'"
                            :value="c_data.conform_module">
                        </RowComponent>
                        <RowComponent
                            v-if="c_data.electronic_seal"
                            :label="'sigillo elettronico presente'"
                            :only_label="true">
                        </RowComponent>
                    </div>
                    <div v-else>
                        <RowComponent
                            :label="'anno di fabbricazione'"
                            :value="c_data.year_production">
                        </RowComponent>
                        <RowComponent
                            :label="'decreto ammissione verifica'"
                            :value="c_data.decree_adminssion">
                        </RowComponent>
                        <RowComponent
                            :label="'ufficio metrico/ispettore'"
                            :value="c_data.metric_office">
                        </RowComponent>
                        <!--RowComponent
                            :label="'anno di marcatura'"
                            :value="c_data.year_marking">
                        </RowComponent-->
                        <RowComponent
                            :label="'data messa in servizio'"
                            :value="c_data.year_commissioning">
                        </RowComponent>
                    </div>
                
                </div>
                <v-form ref="metro" v-else v-model="valid.metro">

                <v-container class="py-0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-radio-group v-model="c_data.metro_national" row>
                                <v-radio
                                    label="certificazione europea"
                                    :value="false"
                                ></v-radio>
                                <v-radio
                                    label="certificazione nazionale"
                                    :value="true"
                                ></v-radio>
                            </v-radio-group>
                            <!--v-checkbox v-model="c_data.metro_national" label="certificazione nazionale" /-->
                        </v-col>
                    </v-row>
                    <div v-if="!c_data.metro_national">
                        <v-row no-gutters>
                        <v-col cols="6" md="4" class="pl-md-0">
                            <v-text-field dense outlined
                                label="anno marcatura CE*"
                                v-model="c_data.CE_year"
                                :rules="[rules.mandatory]"
                                :maxlength="4"
                                :counter="4"
                            />
                        </v-col>
                        
                        <v-col cols="6" md="4" class="pl-2">
                            <v-text-field dense outlined
                            label="numero attestazione/certificazione*"
                            v-model="c_data.cert_number"
                            :rules="[rules.mandatory]"
                        ></v-text-field>   
                        </v-col>
                
                        <v-col cols="6" md="4" class="pl-sm-0 pl-md-2">
                            <v-text-field dense outlined
                                label="org. notificato*"
                                v-model="c_data.org_notified"
                                :rules="[rules.mandatory]"
                            ></v-text-field>   
                        </v-col>
                        
                        <v-col cols="6" md="4" class="pl-md-0 pl-sm-2">
                            <CalendarField
                                label="data messa in servizio*"
                                v-model="c_data.commissioning_date"
                                :rules="[rules.mandatory]"
                            />
                        </v-col>
                        <v-col cols="6" md="4" class="pl-md-2 pl-sm-0">
                            <v-text-field dense outlined
                                label="modulo accertamento conformità"
                                v-model="c_data.conform_module"
                            ></v-text-field>   
                        </v-col>
                        <v-col cols="6" md="4" class="pl-md-2 pl-sm-2">
                            <v-checkbox dense outlined
                                label="sigillo elettronico"
                                v-model="c_data.electronic_seal"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div v-else class="py-0">
                    <v-row no-gutters>
                        <v-col cols="6">
                            <v-text-field dense outlined
                                label="anno di fabbricazione*"
                                v-model="c_data.year_production"
                                :rules="[rules.mandatory, rules.numberRules]"
                                :maxlength="4"
                                :counter="4"
                            />   
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-text-field dense outlined
                                label="decreto ammissione verifica*"
                                v-model="c_data.decree_adminssion"
                                :rules="[rules.mandatory]"
                            ></v-text-field>   
                        </v-col>
                        <v-col cols="6" class="">
                            <v-text-field dense outlined
                                label="ufficio metrico/ispettore*"
                                v-model="c_data.metric_office"
                                :rules="[rules.mandatory]"
                            ></v-text-field>   
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <CalendarField dense outlined
                                label="data messa in servizio*"
                                v-model="c_data.year_commissioning"
                                :rules="[rules.mandatory]"
                            />
                        </v-col>
                    </v-row>
                </div>
                </v-container>
                </v-form>
            </div>
            <div v-else> <!--OTHER TYPE CUSTOM DATA -->
                <div v-if="show_info">
                </div>
                <v-form v-else v-model="valid.metro">
                </v-form>
            </div>
        </div>
    </div>
</template>
<script>
import {getModel} from '../../../utils/model'
import {CustomDataMixin} from "../../../utils/CustomDataMixin.js"
import RowComponent from "../../../components/utils/RowComponent"

// import _ from 'lodash'
export default {
    mixins: [CustomDataMixin],
    components: {RowComponent},
    data() {
        return {
            valid: {
                object: false,
                metro: false
            }
        }
    },
    watch: {
        "c_data.metro_national":
         {
             handler(){

                this.$nextTick(function(){
                    if (!this.show_info) {
                        this.$refs.metro.validate()
                    }
                })
                
            }
        }
    },
    mounted() {
        console.log('CUSTOM AWI')
        let model = null
        if (this.c_type=='object') {
            model = getModel('PlatformCustomAwiScales')
        } else if (this.c_type=='metro') {
            switch(this.r_type) {
                case 'leg':
                    model = getModel('LegalAwiMetroData')
                    break;
                default:
                    break;
            }
        }
        if (model) {
            this.c_data = model(this.o_data)
        } else {
            this.c_data = _.cloneDeep(this.o_data)
        }
        let that = this
        this.$nextTick(function(){
            if (!that.show_info && that.$refs[that.c_type]) {
                that.$refs[that.c_type].validate()
            }
        })
    },
    methods: {
        getData() {
            if (this.c_type=='metro') {
                if (this.c_data.metro_national) {
                    this.c_data.conform_module = ''
                    this.c_data.cert_number = ''
                    this.c_data.org_notified = ''
                    this.c_data.CE_year = ''
                    this.c_data.commissioning_date = ''
                    this.c_data.electronic_seal = ''
                } else {
                    this.c_data.year_production = ''
                    this.c_data.decree_adminssion = ''
                    this.c_data.metric_office = ''
                    this.c_data.year_marking = ''
                    this.c_data.year_commissioning = ''
                }
            }
            return this.c_data
        }
    },
}
</script>

<style>
</style>